import { Panel } from "primereact/panel";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { RestricaoFullResumo } from "./RestricaoFullResumo";

export default function RestricaoFullPJ({ restricaoFullPj }: { restricaoFullPj: any }) {
  const cadastrais = restricaoFullPj?.dados_cadastrais;
  const participacaoSocietaria = restricaoFullPj?.participacao_societaria?.registro || [];

  return (
    <div>
      {restricaoFullPj?.mensagemErro ? (<p>{restricaoFullPj.mensagemErro}</p>) : (<>
        {cadastrais && (
          <div>
            <br />
            <Panel header="Dados Cadastrais">
              <div className="flex-consulta flex-wrap gap-3">
                <div><b>CNPJ:</b> {cadastrais.cnpj}</div>
                <div><b>Razão Social:</b> {cadastrais.razao_social}</div>
                <div><b>Fundação:</b> {cadastrais.data_fundacao}</div>
                <div><b>Situação:</b> {cadastrais.situacao}</div>
                <div><b>Cidade:</b> {cadastrais.cidade}</div>
                <div><b>UF:</b> {cadastrais.uf}</div>
              </div>
            </Panel>
          </div>
        )}
        <RestricaoFullResumo dados={restricaoFullPj} />
        {participacaoSocietaria.length > 0 && (
          <div>
            <br />
            <Panel header="Participação Societária">
              <DataTable size="small" value={participacaoSocietaria} tableStyle={{ minWidth: "50rem" }}>
                <Column field="documento" header="Documento"></Column>
                <Column field="nome" header="Nome"></Column>
                <Column field="percentual" header="Percentual"></Column>
              </DataTable>
            </Panel>
          </div>
        )}
      </>)}
    </div>
  );
}
